import { vibrationRegistry } from "./vibrationRegistry";

export const generateVibrationDefaultMeterDemo = ({ meter_id }) => {
    let selectedArea = null;
    let selectedMachine = null;
    let selectedMotor = null;

    vibrationRegistry.areas.forEach((area) => {
        area.machines.forEach((machine) => {
            machine.motors.forEach((motor) => {
                if (motor.id === Number(meter_id)) {
                    selectedArea = area;
                    selectedMachine = machine;
                    selectedMotor = motor;
                }
            });
        });
    });

    if (!selectedArea || !selectedMachine) {
        return {
            areas: [],
            machines: [],
            meters: [],
            selected_area_id: null,
            selected_machine_id: null,
            selected_meter_id: null,
        };
    }

    return {
        areas: vibrationRegistry.areas.map((a) => ({
            id: a.id,
            area_name: a.area_name,
        })),

        machines: selectedArea.machines.map((m) => ({
            id: m.id,
            machine_name: m.machine_name,
        })),

        meters: selectedMachine.motors.map((m) => ({
            id: m.id,
            motor_name: m.motor_name,
        })),

        selected_area_id: selectedArea.id,
        selected_machine_id: selectedMachine.id,
        selected_meter_id: selectedMotor.id,
    };
};
